// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__9wO4y","table":"Table_table__hUHmb","table__pagination":"Table_table__pagination__v48GD"};